import { Flex, Heading, TabPanel, TabPanels, Text, useBreakpointValue } from "@chakra-ui/react";

function NavigationTabPanels({ elements, tabsCollapsed, callMethod, tabTitle, navTabPanelStyles }) {
  const containerDisplay = useBreakpointValue({ base: "block", md: "flex" });

  return (
    <TabPanels maxWidth={`calc(100% - var(--chakra-sizes-${tabsCollapsed ? 12 : 60}))`}>
      {elements.map((element, index) => {
        const FormComponent = element.component;
        const CustomHeaderComponent = element.CustomHeaderComponent;
        const customHeaderProps = element.customHeaderProps;
        const title = element.customTabPanelTitle ?
          element.customTabPanelTitle : tabTitle ? `${tabTitle} ${index + 1}` : null;

        return (
          <TabPanel key={`tabpanel_${element.id}`} blockSize="full" padding="0"
                    paddingInline="5" {...navTabPanelStyles}>
            {CustomHeaderComponent ?
              <Flex
                justifyContent="space-between"
                display={containerDisplay}
                paddingInlineStart={containerDisplay === "block" ? 4 : 0}
              >
                <Heading
                  as="h2"
                  fontSize="xl"
                  marginBlock="2"
                  title={title}
                  textOverflow="ellipsis"
                  overflow="hidden"
                  whiteSpace="nowrap"
                >
                  {title}
                </Heading>
                <CustomHeaderComponent questionnaireId={element.data.questionnaireId} {...customHeaderProps ?? null} />
              </Flex> :
              title && <Heading
                as="h2"
                fontSize="xl"
                marginBlock="2"
                title={title}
                textOverflow="ellipsis"
                overflow="hidden"
                whiteSpace="nowrap"
              >
                {title}
              </Heading>
            }
            {element.description && typeof element.description !== "undefined" && element.description !== "" ?
              <Text opacity="0.75" fontSize="sm">
                {element.description}
              </Text> : null
            }
            <FormComponent
              tabKey={element.id}
              currentElement={element.data}
              callMethod={callMethod}
              isPreview={callMethod === null}
              reportId={element.reportId}
            />
          </TabPanel>
        );
      })}
    </TabPanels>
  );
}

export default NavigationTabPanels;
